import { IState } from '../reducers'

export const getSummaryTopics = (state: IState): any => state.summary.topics
export const getSummaryEventTopics = (state: IState): any => state.summary.evttopics
export const getSummaryReferenceSourceRating = (state: IState): any => state.summary.referenceSourceRating
export const getSummaryReferenceSourceTopics = (state: IState): any => state.summary.referenceSourceTopics
export const getSummarySourceThemes = (state: IState): any => state.summary.referenceSourceThemes
export const getSummaryDigest = (state: IState): any => state.summary.digest
